import {
  useAccountFilter,
  useCurrentWorkspace,
  useSetAccountFilter,
} from '@gripp/shared-logic';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { EntitySearchInput } from './entitySearchInput';

export const AccountSearchInput = ({
  onBlur,
  autoFocus,
}: { onBlur?: () => void; autoFocus?: boolean } = {}) => {
  const { t } = useTranslation();
  const { workspaceId } = useParams();
  const { data: filter } = useAccountFilter();
  const { mutateAsync } = useSetAccountFilter();
  const impersonatingWorkspace = useCurrentWorkspace(true);

  const currentWorkspaceId = useCallback(() => {
    if (workspaceId) return workspaceId;
    if (impersonatingWorkspace) return impersonatingWorkspace.id;
    return undefined;
  }, [impersonatingWorkspace, workspaceId]);

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.workspaceId = currentWorkspaceId();
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('account.filter.searchPlaceholder')}
      onBlur={onBlur}
      autoFocus={autoFocus}
    />
  );
};
